import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterOption } from '../../loop-v2-filters.service';

interface SalespeopleDialogData {
  selected: string[];
  options: Observable<FilterOption[]>;
  title: string;
  placeholder: string;
}

@Component({
  selector: 'sales-common-multi-selection-dialog',
  templateUrl: './multi-selection-dialog.component.html',
  styleUrls: ['./multi-selection-dialog.component.scss'],
})
export class MultiSelectionDialogComponent implements OnInit {
  formControl = new UntypedFormControl();
  options$: Observable<FilterOption[]>;

  constructor(
    public dialogRef: MatDialogRef<MultiSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SalespeopleDialogData,
  ) {}

  ngOnInit(): void {
    this.formControl.setValue(this.data.selected);

    this.options$ = this.data.options;
  }

  close(newData: boolean): void {
    if (!newData) {
      this.dialogRef.close();
      return;
    }
    this.dialogRef.close(this.formControl.value || []);
  }
}
